const MAX_CHARTBEAT_SECTION_LENGTH = 63;

const BENZINGA_TITLE_SUFFIX = /\s*(?:\||[-–])\s+Benzinga\s*$/i;

export function getChartbeatSectionFromQuoteTitle(quotePageTitle: string): string {
  const titleWithoutBenzingaSuffix = quotePageTitle.replace(BENZINGA_TITLE_SUFFIX, '').trim();
  const sanitizedQuoteTitle = titleWithoutBenzingaSuffix
    .replace(/\|/g, '/')
    .replace(/,/g, ' ·')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, MAX_CHARTBEAT_SECTION_LENGTH)
    .trim();

  if (!sanitizedQuoteTitle) return 'Quotes';
  return `Quotes, ${sanitizedQuoteTitle}`;
}
